





















import { Component, Vue, Prop } from 'vue-property-decorator'
@Component
export default class extends Vue {
  @Prop({}) private idModal
  @Prop({}) private label
  @Prop({}) private imageHasSelect

  public openModal() {
    this.$root.$emit('bv::show::modal', this.idModal)
  }
}
